<app-block [name]="blockUiName">
  @if (permissionLoaded | async) {
    <div
      class="ImproverLayout"
      [class.has-navbar]="navbarVisible"
      [style.--nav-header-dynamic-height]="dynamicHeaderHeightPx()"
      app-mobile-class
      app-desktop-class>
      @if (isMobileBannerVisible()) {
        <lay-improver-mobile-banner (bannerDismissed)="dismissMobileBanner($event)" />
      }
      @if (isTestEnvironmentBannerVisible()) {
        @defer (when isTestEnvironmentBannerVisible()) {
          <lay-maintenance-general-issue
            [message]="'APP_TEST_ENVIRONMENT_BANNER_MESSAGE'"
            [dismissible]="false"
            [isDanger]="true" />
        }
      }

      @if (isMaintenanceMessageVisible()) {
        @defer (when isMaintenanceMessageVisible()) {
          <lay-maintenance-general-issue
            [message]="maintenanceMessage()"
            (messageDismissed)="dismissMaintenanceMessage($event)" />
        }
      }
      @if (navbarVisible) {
        @defer (when navbarVisible) {
          <div
            class="ImproverLayout-navbar"
            app-custom-theme
            [app-mobile-class]>
            <lay-improver-navbar
              [userActionsVisible]="navbarActionsVisible"
              [offcanvasVisible]="offcanvasMenuVisible"
              [logoLink]="navbarLogoLink">
            </lay-improver-navbar>
          </div>
        }
      }
      <div
        class="ImproverLayout-page"
        [class.has-sidebar]="sidebarVisible"
        [class.is-collapsed]="isSidebarCollapsed()"
        [class.is-unscrollable]="noScroll"
        [app-mobile-class]>
        <div [impDrawerContainer]="mainDrawerId">
          <ng-content></ng-content>
        </div>
        @if (sidebarVisible) {
          @defer (when sidebarVisible) {
            <div
              *app-desktop
              app-custom-theme
              class="ImproverLayout-sidebar">
              <lay-improver-sidebar [attr.id]="sidebarContainerId"></lay-improver-sidebar>
            </div>
          }
        }

        @defer (when isChatAvailable()) {
          <chat-chatbot-wrapper
            *app-desktop
            class="ImproverLayout-chat"
            [hiddenChat]="!sidebarVisible" />
        }

        <div
          class="ImproverLayout-content"
          [attr.id]="contentLayoutContainerId"
          [app-mobile-class]
          [class.is-noLayoutContentScroll]="noLayoutContentScroll"
          [class.is-extended]="!sidebarVisible">
          <router-outlet></router-outlet>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  }
</app-block>
